/* eslint-disable */
export default {
  infoMessageMins: 'Anmeldung automatisch speichern in {delayTime} Minuten...',
  infoMessageMin: 'Anmeldung automatisch speichern in {delayTime} Minute...',
  infoMessageSecs: 'Anmeldung automatisch speichern in {delayTime} Sekunden...',
  infoMessageSec: 'Anmeldung automatisch speichern in {delayTime} Sekunde...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
